import * as CSS from "csstype"
import { system } from "styled-system"

const transition = system({
  transition: true,
})

export interface TransitionProps {
  transition?: CSS.Property.Transition
}

export default transition
